import React from "react";

import { PropsTypeSvg } from "@typings/global.types";

function CharacterCursor({ classNameProps, height, width }: PropsTypeSvg) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={classNameProps}
      width={width}
      height={height}
      viewBox='0 0 4 35'
      fill='none'
    >
      <rect width='4' height='35' rx='2' fill='#00ACFF' />
    </svg>
  );
}

export default CharacterCursor;
